import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { CardLoadingIndicator } from '@components/card-loader-indicator';
import CardWrapper, { ICardProps } from '@components/cards/card-wrapper';
import { IFeatureFlagsRequest } from '@telstra-connect/service-requests/state/feature-flags-data';
import { connect } from 'react-redux';
import { IServiceRequestsAppState } from '@service-requests/store-state';
import { headerName } from '@telstra-connect/service-requests/helpers/common-static-data';
import { NewCardLoadingIndicator } from '@components/new-card-loader-indicator';
import global from '@applications'

const { lazy } = React;
const DashboardCard = lazy(() => import(/* webpackChunkName:"service-request-card" */'./index'));
type IServiceRequestsCardOwnProps = ICardProps;

interface IServiceRequestCardStateProps {
    featureFlagData?: IFeatureFlagsRequest;
}

class Card extends React.Component<IServiceRequestsCardOwnProps & IServiceRequestCardStateProps> {
    public render() {
        const viewAggregatedYPSpage = this.props.featureFlagData
            && this.props.featureFlagData.data
            && this.props.featureFlagData.data.viewAggregatedYPSpage;
        const cardTitle = viewAggregatedYPSpage
            ? headerName.ypsLandingPageHeader
            : headerName.yourRequestHeader;
        const showRedesignedTile =
          global.applications.Platform.redesignDataRichTiles;
        const showRedesignedTilePhase2 =
          global.applications.Platform.redesignTilesPhase2;
        const showNewTile = showRedesignedTilePhase2 || showRedesignedTile;
        return (
            <LazyLoadComponentWrapper
                fallback={
                    showNewTile ? (
                        <NewCardLoadingIndicator error={false} cardTitle={cardTitle} />
                    ) : (
                        <CardLoadingIndicator error={false} cardTitle={cardTitle} />
                    )
                }
                errorIndicator={
                    showNewTile ? (
                        <NewCardLoadingIndicator error={true} cardTitle={cardTitle} />
                    ) : (
                        <CardLoadingIndicator error={true} cardTitle={cardTitle} />
                    )
                }
            >
                <DashboardCard {...this.props} />
            </LazyLoadComponentWrapper>
        );
    }
};

const mapStateToProps = (state: IServiceRequestsAppState): IServiceRequestCardStateProps => ({
    featureFlagData: state.serviceRequests.featureFlagsData
});

export default connect<
IServiceRequestCardStateProps,
{},
ICardProps,
IServiceRequestsAppState
>(mapStateToProps, null)(CardWrapper(Card));
